import React from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

const DaysToggleButton = ({ state, onChange }) => {
  const control = {
    value: state.type,
    exclusive: true,
  }

  const toggleStyle = () => {
    return {
      '&.Mui-selected': {
        color: 'alternate.main',
        backgroundColor: 'alternate.light',
        border: 1,
        '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
          borderLeft: 1,
        },
      },
      '&:hover': {
        color: 'alternate.main',
        backgroundColor: 'gray-background.main',
      },
      width: { xs: '100%', lg: '10vw' },
    }
  }

  return (
    <ToggleButtonGroup fullWidth onChange={onChange} {...control}>
      <ToggleButton sx={{ ...toggleStyle() }} value="Full Day">
        Full Day
      </ToggleButton>
      <ToggleButton sx={{ ...toggleStyle() }} value="AM">
        Half Day {`(`}AM{`)`}
      </ToggleButton>
      <ToggleButton sx={{ ...toggleStyle() }} value="PM">
        Half Day {`(`}PM{`)`}
      </ToggleButton>
      <ToggleButton sx={{ ...toggleStyle() }} value="Rest Day">
        Rest Day
      </ToggleButton>
      <ToggleButton sx={{ ...toggleStyle() }} value="Off Day">
        Off Day
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default DaysToggleButton
